<template>
  <div name="hrms31e-group">
    <div class="evaluation-header clearfix cursor-pointer border-top-color-skin" @click="toggleGroup()">
      <div class="col-xs-8 clear-padding">
        <div class="col-xs-12 col-md-6 clear-padding">{{ labels['HRPM31EP2']['20'] }} {{ dataGroup.numgrup }}</div>
        <div class="col-xs-12 col-md-6 clear-padding evaluation-title">{{ dataGroup.desc_numgrup }}</div>
      </div>
      <div class="col-xs-4 clear-padding evaluation-score">{{ calResultScore(dataGroup) }}/{{ calTotalScore(dataGroup) }}</div>
    </div>
    <div class="evaluation-body" v-show="groupDisp">
      <div class="evaluation-section clearfix">
        <template v-for="(item, index) in dataGroup.numitem">
          <hrms31e-item :dataGroup="dataGroup"
                        :item="item"
                        :choices="choices"
                        :name="name"
                        :changeChoice="changeChoice" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import hrms31eItem from 'components/hrms31e/item'

export default {
  name: 'hrms31e-group',
  data () {
    return {
      groupDisp: false
    }
  },
  props: {
    labels: {
      type: Object
    },
    dataGroup: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    changeChoice: {
      type: Function
    }
  },
  methods: {
    toggleGroup () {
      this.groupDisp = !this.groupDisp
    },
    calResultScore (dataGroup) {
      let groupQtyscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyscor', Number.parseFloat(groupQtyscor).toFixed(2))
      return Number.parseFloat(groupQtyscor).toFixed(2)
    },
    calTotalScore (dataGroup) {
      let groupQtyfscor = dataGroup.numitem.map((item) => {
        return parseFloat(item.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
      this.$set(dataGroup, 'qtyfscor', Number.parseFloat(groupQtyfscor).toFixed(2))
      return Number.parseFloat(groupQtyfscor).toFixed(2)
    }
  },
  components: {
    hrms31eItem
  }
}
</script>



// WEBPACK FOOTER //
// group.vue?73be24f7